// extracted by mini-css-extract-plugin
export var container = "history-alert-module--container--KFA93";
export var containerPosition = "history-alert-module--containerPosition--jdesl";
export var heading = "history-alert-module--heading--oPP9B";